import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, useTheme } from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const PayslipLoadError = ({ messages, onRetry }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [open, setOpen] = useState(true)
  const reason = Array.isArray(messages) && messages.filter(Boolean).length
    ? messages.filter(Boolean).join(" ")
    : t("payslip.load_failed_reason", "The payslip service did not respond in time. Please try again.")

  return (
    <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="payslip-load-error-title" maxWidth="xs">
      <Grid container direction="column" alignItems="center">
        <Box bgcolor="error.light" width="1" mb={2} textAlign="center">
          <Grid item my={2}>
            <DialogTitle id="payslip-load-error-title">
              <Box className="fa-layers fa-fw text-center fa-3x">
                <FontAwesomeIcon icon={faCircle} color={theme.palette.error.main} />
                <FontAwesomeIcon icon={faTimes} color={theme.palette.error.contrastText} inverse size="xs" />
              </Box>
            </DialogTitle>
          </Grid>
        </Box>
        <DialogContent>
          <Typography align="center" variant="h4" paragraph>
            {t("payslip.load_failed", "Could not load payslips.")}
          </Typography>
          <Typography align="center" paragraph>
            {reason}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box mb={3} display="flex" gap={1}>
            <Button onClick={() => setOpen(false)} color="primary" variant="outlined">
              {t("global.buttons.cancel", "Cancel")}
            </Button>
            <Button onClick={onRetry} color="primary" variant="contained">
              {t("payslip.try_again", "Try again")}
            </Button>
          </Box>
        </DialogActions>
      </Grid>
    </Dialog>
  )
}

export default PayslipLoadError
